export const CREATE_EMPLOYEE_FAILURE = 'CREATE_EMPLOYEE_FAILURE';

export const createEmployeeFailure = error => ({
    type: CREATE_EMPLOYEE_FAILURE,
    payload: error,
    error: true,
});
